import {ADD_EMPTY_ROW} from "../../reducers/cleaningPlanReducer";

export function addEmptyRow(projectId, vehicleId) {
    return {
        type: ADD_EMPTY_ROW,
        payload: {projectId, vehicleId}
    }
}